import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { BreadcrumbProvider } from '@dxaas/frontend-core'

import { guardarReturnTo } from './returnTo'

// TDD-035 — sin Sidebar/Header: la aplicación de negocio controla toda la
// pantalla y es responsable de facilitar su propio mecanismo de retorno
// (ver returnTo.ts + buildVistaRoutes, que expone componentProps.returnTo
// al RemoteApp montado acá). Ningún singleton de plataforma (auth, tenant,
// react-query) vive en Header/Sidebar — ambos son consumidores de
// contexto, no proveedores — así que omitirlos acá no afecta su
// disponibilidad para el remote.
//
// BreadcrumbProvider SÍ se monta acá (2026-08-31, AI Application Builder,
// ADR-0011/TDD-001 §13) — no para mostrar un breadcrumb visual (`blank` no
// renderiza ninguno, y eso no cambia), sino porque es el único canal que
// cruza Module Federation (react shared dependency) para que un remote
// pida navegar a otra vista de su misma aplicación sin full page reload
// (ViewNavigationRequest, ver BreadcrumbContext.ts en @dxaas/frontend-core
// y RemoteVistaRoute en router/index.tsx, que consume la solicitud).
export const ApplicationBlankLayout: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    const from = (location.state as { from?: string } | null)?.from
    if (from) {
      guardarReturnTo(from)
    }
  }, [location.state])

  return (
    <BreadcrumbProvider>
      <div className="h-screen w-screen overflow-auto bg-gray-50">
        <Outlet />
      </div>
    </BreadcrumbProvider>
  )
}
